<footer class="footer text-center py-4">
    <small class="copyright">
        &copy; 
        <a href="https://garethjohnstone.co.uk/?ref=self" target="_blank">
            Gareth Johnstone
        </a>
    </small>
</footer>